module.exports = __webpack_public_path__ + "img/pr-2.2792ff1e.png";